import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyPublishedModules {
    static readonly type = '[MyPublishedModules] SetMyPublishedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyPublishedModules {
    static readonly type = '[MyPublishedModules] UnsetMyPublishedModules';
}

export class AddMyPublishedModules {
    static readonly type = '[MyPublishedModules] AddMyPublishedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyPublishedModule {
    static readonly type = '[MyPublishedModules] FetchMyPublishedModule';

    constructor(public payload: string) {}
}

export class FetchMyPublishedModules {
    static readonly type = '[MyPublishedModules] FetchMyPublishedModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isRunning?: boolean;
            participantId?: string;
            tag?: number[];
        }
    ) {}
}

export class FetchMyPublishedModulesSuccess {
    static readonly type = '[MyPublishedModules] FetchMyPublishedModulesSuccess';
}

export class FetchMyPublishedModulesFailure {
    static readonly type = '[MyPublishedModules] FetchMyPublishedModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyPublishedModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyPublishedModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyPublishedModules] DeselectSelectedModules';
}

export class SearchMyPublishedModules {
    static readonly type = '[MyPublishedModules] SearchMyPublishedModules';

    constructor(public payload: string) {}
}

export class SortMyPublishedModules {
    static readonly type = '[MyPublishedModules] SetMyPublishedModulesSort';

    constructor(public payload: Sort) {}
}
